function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { changePassword, closeModal } from "@common/actions";
import Spinner from "@common/components/Spinner";
import { validatePassword } from "@common/services/helpers";
import { DELETE_IN_CHANGE_PASSWORD_ENABLED, ERROR_SUBCODE_PASSWORDS_DONT_MATCH, REGEX_PASSWORD, ROUTE_ACCOUNT_DELETE, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS } from "@config/constants";
import { withRouter } from "react-router-dom";
var ChangePassword = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ChangePassword, PureComponent);
    var _super = _create_super(ChangePassword);
    function ChangePassword(props) {
        _class_call_check(this, ChangePassword);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            oldPassword: "",
            oldPasswordError: "",
            oldPasswordTouched: false,
            newPassword: "",
            newPasswordError: "",
            newPasswordTouched: false,
            newPasswordRepeat: "",
            newPasswordRepeatError: "",
            newPasswordRepeatTouched: false,
            serverError: "",
            changeRequestPending: false
        };
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.changePassword = _this.changePassword.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ChangePassword, [
        {
            /**
     * Mark all inputs that use validation
     * as touched, which will trigger
     * the validation (see `componentDidUpdate`).
     */ key: "markInputsAsTouched",
            value: function markInputsAsTouched() {
                this.setState({
                    oldPasswordTouched: true,
                    newPasswordTouched: true,
                    newPasswordRepeatTouched: true
                });
            }
        },
        {
            key: "changePassword",
            value: /**
     * Sends user's credentials to the backend
     * if there are no password errors.
     * If server responds with specific error,
     * it sets `serverError` and marks text
     * inputs as touched.
     * @returns {Promise<void>}
     */ function changePassword() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, oldPassword, oldPasswordError, oldPasswordTouched, newPasswordError, newPasswordTouched, newPassword, newPasswordRepeat, newPasswordRepeatError, newPasswordRepeatTouched, errors, _this_props, toggleComponent, componentMap, enqueueSnackbar, i18n, componentName, hasInvalidInputDataAfterBlur, hasInvalidInputDataBeforeBlur, data, response, error, hasSpecificServerError, errorText;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.state.changeRequestPending) return [
                                    3,
                                    4
                                ];
                                _this_state = _this.state, oldPassword = _this_state.oldPassword, oldPasswordError = _this_state.oldPasswordError, oldPasswordTouched = _this_state.oldPasswordTouched, newPasswordError = _this_state.newPasswordError, newPasswordTouched = _this_state.newPasswordTouched, newPassword = _this_state.newPassword, newPasswordRepeat = _this_state.newPasswordRepeat, newPasswordRepeatError = _this_state.newPasswordRepeatError, newPasswordRepeatTouched = _this_state.newPasswordRepeatTouched;
                                errors = _this.props.i18n.errors;
                                _this_props = _this.props, toggleComponent = _this_props.toggleComponent, componentMap = _this_props.componentMap, enqueueSnackbar = _this_props.enqueueSnackbar, i18n = _this_props.i18n, componentName = _this_props.componentName;
                                hasInvalidInputDataAfterBlur = oldPasswordError || newPasswordError || newPasswordRepeatError;
                                hasInvalidInputDataBeforeBlur = !oldPasswordTouched && !validatePassword(oldPassword, null) || !newPasswordTouched && !validatePassword(newPassword, null) || !newPasswordRepeatTouched && !validatePassword(newPasswordRepeat, null);
                                if (hasInvalidInputDataAfterBlur || hasInvalidInputDataBeforeBlur) {
                                    return [
                                        2,
                                        _this.markInputsAsTouched()
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                data = {
                                    oldpass: oldPassword,
                                    password: newPassword,
                                    repeatPassword: newPasswordRepeat
                                };
                                _this.setState({
                                    changeRequestPending: true
                                });
                                return [
                                    4,
                                    _this.props.changePassword(data)
                                ];
                            case 2:
                                response = _state.sent();
                                _this.setState({
                                    changeRequestPending: false
                                });
                                if (response.status === STATUS_CODE_SUCCESS) {
                                    enqueueSnackbar(i18n.snackbar.changePasswordSuccess, {
                                        variant: SNACKBAR_VARIANT_SUCCESS,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                    toggleComponent(componentMap[componentName].parentComponentName);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    errorText = errors["error".concat(error.subcode)];
                                    enqueueSnackbar(i18n.snackbar.changePasswordFail, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                    _this.setState({
                                        changeRequestPending: false
                                    });
                                    switch(error.subcode){
                                        case ERROR_SUBCODE_PASSWORDS_DONT_MATCH:
                                            _this.setState({
                                                newPasswordError: errorText,
                                                repeatNewPasswordError: errorText,
                                                serverError: ""
                                            });
                                            break;
                                        default:
                                            _this.setState({
                                                serverError: errorText
                                            });
                                    }
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     *  Validates a password and sets the appropriate
     *  error in the state.
     * @param {string} key - `oldPassword` or `newPassword` or `repeatNewPassword`
     */ key: "validatePassword",
            value: function validatePassword(key) {
                var validityError = REGEX_PASSWORD.test(this.state[key]) ? "" : this.props.i18n.authentication.enterPassword;
                var matchError = "";
                if (key !== "oldPassword") {
                    matchError = this.state.newPassword === this.state.newPasswordRepeat ? "" : this.props.i18n.authentication.passwordsDontMatch;
                }
                this.setState(_define_property({}, "".concat(key, "Error"), validityError || matchError));
            }
        },
        {
            /**
     * Sets the new state for a given input.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(event) {
                var _event_target = event.target, checked = _event_target.checked, name = _event_target.name, type = _event_target.type, value = _event_target.value;
                var isCheckbox = type === "checkbox";
                var key = isCheckbox ? value : name;
                var newValue = isCheckbox ? checked : value;
                this.setState(_define_property({}, key, newValue));
            }
        },
        {
            /**
     * Renders the inputs.
     * @returns {*}
     */ key: "renderInputs",
            value: function renderInputs() {
                var _this = this;
                var _this_state = this.state, oldPassword = _this_state.oldPassword, oldPasswordError = _this_state.oldPasswordError, newPassword = _this_state.newPassword, newPasswordError = _this_state.newPasswordError, newPasswordRepeat = _this_state.newPasswordRepeat, newPasswordRepeatError = _this_state.newPasswordRepeatError, serverError = _this_state.serverError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        oldPasswordTouched: true
                                    });
                                },
                                onFocus: function() {
                                    return _this.setState({
                                        serverError: ""
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: oldPasswordError !== "" || serverError !== "",
                            helperText: oldPasswordError || serverError,
                            id: "oldPassword",
                            type: "password",
                            name: "oldPassword",
                            value: oldPassword,
                            required: true,
                            label: i18n.account.enterOldPassword,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root no-autofill",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        newPasswordTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: newPasswordError !== "",
                            helperText: newPasswordError,
                            id: "new-password",
                            type: "password",
                            name: "newPassword",
                            value: newPassword,
                            required: true,
                            label: i18n.account.enterNewPassword,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        newPasswordRepeatTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: newPasswordRepeatError !== "",
                            helperText: newPasswordRepeatError,
                            id: "repeat-new-password",
                            type: "password",
                            name: "newPasswordRepeat",
                            value: newPasswordRepeat,
                            required: true,
                            label: i18n.account.repeatNewPassword,
                            onChange: this.onChange,
                            margin: "none"
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, componentMap = _this_props.componentMap, componentName = _this_props.componentName, toggleComponent = _this_props.toggleComponent;
                var parentProps = componentMap[componentName].parentProps;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "main-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "change-password-wrapper",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "change-password-form-wrapper paper-card small light",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "head",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-key"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text",
                                                    children: i18n.account.changePassword
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "details",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            className: "change-password-form",
                                            autoComplete: "off",
                                            children: this.renderInputs()
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-footer",
                            children: [
                                DELETE_IN_CHANGE_PASSWORD_ENABLED ? /*#__PURE__*/ _jsx(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    color: "primary",
                                    onClick: function() {
                                        _this.props.history.push(ROUTE_ACCOUNT_DELETE);
                                        _this.props.closeModal();
                                    },
                                    className: "delete-account-button button-no-background float-left",
                                    children: i18n.account.deleteAccount
                                }) : !parentProps.onlyChangePassword && /*#__PURE__*/ _jsxs(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    onClick: function() {
                                        return toggleComponent(componentMap[componentName].parentComponentName, parentProps);
                                    },
                                    className: "button-no-background go-back-button raised half-width float-left center-vertical",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-keyboard-arrow-right"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: i18n.account.goBack
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    onClick: this.changePassword,
                                    className: "button raised half-width float-right center-vertical send-form-button",
                                    children: this.state.changeRequestPending ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "icon icon-save"
                                            }),
                                            i18n.account.save
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                if (this.state.oldPasswordTouched) {
                    this.validatePassword("oldPassword");
                }
                if (this.state.newPasswordTouched) {
                    this.validatePassword("newPassword");
                }
                if (this.state.newPasswordRepeatTouched) {
                    this.validatePassword("newPasswordRepeat");
                }
            }
        }
    ]);
    return ChangePassword;
}(PureComponent);
export default withRouter(withSnackbar(connect(null, {
    changePassword: changePassword,
    closeModal: closeModal
})(ChangePassword)));
